// extracted by mini-css-extract-plugin
export default {"iconContainer":"Icon_iconContainer__5FbSF","icon":"Icon_icon__-FZub"};